import { useEffect, useState } from 'react';

/** `value`, updated only once it has stopped changing for `ms` milliseconds. */
export function useDebounced<T>(value: T, ms = 220) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}
